import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import {
  addStudentDetail,
  studentIdEnable,
} from '../../../redux/modules/studentDetail';
import { TOOLTIP_POSITION_BOTTOM } from '../../../utils/dom-utils';
import ToolTip from '../../Shared/ToolTip/ToolTip';
import {
  addSchoolValidationFields,
  handleMultipleValidations,
} from '../CollegeDistributeSteps/Validations';
import './CollegeDistributeStudentInformation.scss';
import { getStudentName } from '../../../utils/utils';

const message1 =
  "The beneficiary's Student Id as issued by the " +
  'educational institution that the beneficiary is ' +
  "attending. The beneficiary's Social Security " +
  'number should not be used. Please enter ' +
  'alphabetic or numeric characters only. ';

const message2 =
  'If the Student name and ID exceed the ' +
  'maximum of 35 characters, the student name will ' +
  'be truncated to print on the check.';

const TOOLTIP_MESSAGE = (
  <>
    <>{message1}</>
    <p>{message2}</p>
  </>
);

export const readOnlyStudentId = (studentDetail, fund) => {
  if (studentDetail?.studentIdEnable?.agreementId) {
    if (studentDetail?.studentIdEnable?.agreementId === fund.agreementID) {
      return false;
    } else {
      return studentDetail?.studentIdEnable?.enableFlag;
    }
  }
  return false;
};

const CollegeDistributeStudentInformation = ({
  agreementParties,
  studentDetail,
  fund,
}) => {
  const [studID, setStudID] = useState('');
  const [errors, setErrors] = useState({
    id: false,
  });

  const dispatch = useDispatch();

  const isValidID = (value) => {
    const isValid = handleMultipleValidations(
      value,
      addSchoolValidationFields.studentId
    );
    const previousErrors = { ...errors };
    if (typeof isValid === 'string') {
      previousErrors.id = isValid;
    }
    if (typeof isValid === 'boolean' && isValid) {
      previousErrors.id = false;
    }
    setErrors({ ...previousErrors });

    return isValid;
  };
  const handleOnChange = (event) => {
    const {
      target: { value },
    } = event;
    if (isValidID(value)) {
      setStudID(value);
    }
    dispatch(
      studentIdEnable({
        agreementId: fund?.agreementID,
        enableFlag: Boolean(value),
        fund: fund,
      })
    );
  };

  const minorStudentName = agreementParties
    ? agreementParties.find((party) => party.roleCode === 'MINR')?.fullName
    : '';

  useEffect(() => {
    const { firstName, middleName, lastName, suffix } =
      getStudentName(minorStudentName);
    dispatch(
      addStudentDetail({
        id: studID,
        firstName,
        middleName,
        lastName,
        suffix,
      })
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [studID, dispatch]);

  useEffect(() => {
    if (studentDetail?.student) {
      setStudID(studentDetail?.student.id);
    }
  }, [studentDetail]);

  const getClassName = (fieldName) =>
    fieldName && !readOnlyStudentId(studentDetail, fund)
      ? 'box-error blocked_data'
      : 'input-success blocked_data';

  return (
    <div className="college-distribute-student-container">
      Please Enter All Information Below
      <div className="college-distribute-student">
        <div className="college-student-name">
          <label>Student Name</label>
          <label data-testid="minorName" className="student-name blocked_data">
            {minorStudentName}
          </label>
        </div>
        <div className="college-student-id">
          <label>
            Student Id (required)
            <ToolTip
              header={'Student ID'}
              message={TOOLTIP_MESSAGE}
              placement={TOOLTIP_POSITION_BOTTOM}
            />
          </label>
          {readOnlyStudentId(studentDetail, fund) ? (
            <label className="student-id blocked_data">{studID}</label>
          ) : (
            <div className="studentid-view">
              <input
                className={getClassName(errors.id)}
                type="text"
                id="student-id"
                data-testid="student-id"
                name="student-id"
                onChange={handleOnChange}
                value={studID}
                readOnly={readOnlyStudentId(studentDetail, fund)}
                maxLength="30"
              />
              {errors.id && !readOnlyStudentId(studentDetail, fund) && (
                <div className="error-id">{errors.id}</div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CollegeDistributeStudentInformation;
